import {DopamineChatStreamEvent} from 'interfaces'
import {DopamineRunEvent} from './DopamineAssistant.types'

type MapChatEventOptions = {
  event: DopamineChatStreamEvent
  runErrorMessage: string
  runId: string
}

export const mapChatEvent = ({
  event,
  runErrorMessage,
  runId,
}: MapChatEventOptions): DopamineRunEvent => {
  const occurredAt = Date.now()

  switch (event.type) {
    case 'RUN_STARTED':
    case 'RUN_FINISHED':
      return {occurredAt, runId: event.runId, type: event.type}
    case 'RUN_ERROR':
      return {
        displayMessage: runErrorMessage,
        occurredAt,
        runId,
        type: event.type,
      }
    case 'TEXT_MESSAGE_START':
    case 'TEXT_MESSAGE_END':
      return {messageId: event.messageId, occurredAt, runId, type: event.type}
    case 'TEXT_MESSAGE_CONTENT':
      return {
        delta: event.delta,
        messageId: event.messageId,
        occurredAt,
        runId,
        type: event.type,
      }
    case 'STEP_STARTED':
      return {
        activeLabel: event.displayName,
        completedLabel: event.displayName,
        itemId: `step:${event.stepName}`,
        occurredAt,
        runId,
        type: event.type,
      }
    case 'STEP_FINISHED':
      return {
        completedLabel: event.displayName,
        itemId: `step:${event.stepName}`,
        occurredAt,
        runId,
        type: event.type,
      }
    case 'TOOL_CALL_START':
      return {
        activeLabel: event.displayName,
        completedLabel: event.displayName,
        itemId: `tool:${event.toolCallId}`,
        occurredAt,
        runId,
        type: event.type,
      }
    case 'TOOL_CALL_END':
    case 'TOOL_CALL_RESULT':
      return {
        itemId: `tool:${event.toolCallId}`,
        occurredAt,
        runId,
        type: event.type,
      }
  }
}
